function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.838 4.669A4.169 4.169 0 1 1 4.668.5a4.167 4.167 0 0 1 4.17 4.17zM8 8l2 2",
  className: "search_svg__search_svg__search_svg__cls-1"
});

var SvgSearch = function SvgSearch(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 11 11"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMC43MzYzNSAxMC43MjMxNSI+Cgk8ZGVmcz4KCQk8c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzIzMWYyMDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9PC9zdHlsZT4KCTwvZGVmcz4KCTx0aXRsZT5zZWFyY2g8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjg5MTYsMTYuOTg3M2E0LjE2ODcsNC4xNjg3LDAsMSwxLTQuMTY4OS00LjE2ODlBNC4xNjcxMyw0LjE2NzEzLDAsMCwxLDIwLjg5MTYsMTYuOTg3M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMi4wNTQyIC0xMi4zMTg0KSIvPgoJPGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iNy42MjY1IiB5MT0iNy42MjAxIiB4Mj0iMTAuMzgzMyIgeTI9IjEwLjM2OTEiLz48L3N2Zz4=";
export { SvgSearch as ReactComponent };